import React from "react";

const CustomButton = ({ icon: Icon, onClick, text, hoverWidth = null }) => {
  // alert(hoverWidth);

  return (
    <button
      className={`group flex w-8 ${
        hoverWidth ? "hover:w-[150px]" : ""
      } hover:w-24 items-center justify-between gap-2 border text-base h-7 border-primary rounded-md p-2 focus:outline-none transition-all duration-[400ms] ease-out hover:bg-primary hover:text-white`}
      onClick={onClick}
    >
      {Icon && <Icon className="group-hover:text-white text-primary text-lg" />}
      <p className="hidden group-hover:block text-white whitespace-nowrap">
        {text}
      </p>
    </button>
  );
};

export default CustomButton;
